(() => {
  const sections = document.querySelectorAll('[data-ss-announcement-bar]');

  if (!sections.length) {
    return;
  }

  const root = document.documentElement;

  const updateHeight = (section) => {
    root.style.setProperty('--ss-announcement-bar-height', `${Math.ceil(section.getBoundingClientRect().height)}px`);
  };

  sections.forEach((section) => {
    const refresh = () => updateHeight(section);

    refresh();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(refresh);
      observer.observe(section);
      window.addEventListener('load', refresh, { once: true });
    } else {
      window.addEventListener('resize', refresh);
      window.addEventListener('load', refresh, { once: true });
    }
  });
})();
